export const dashboard = {
  chooseGame: 'Choose<accent> your</accent> game',
  chests: {
    title: 'Play.<br /><accent>Every</accent> day.',
    wording: 'Play each day in a row to have more powerful bonuses!',
    dayLabel: 'DAY {{day}}',
    rewardEmpty: 'Sorry, mate.\nNo luck today.\nCheck in tomorrow.',
    rewardAchievementFallback: 'Achievement',
    loadError: 'Could not load daily rewards. Please try again.',
    openError: 'Could not open the chest. Please try again.',
    retry: 'Retry',
  },
  leaderboard: {
    title: 'Leaderboards',
    period: {
      today: 'Today',
      week: 'Week',
      month: 'Month',
      all: 'All time',
    },
    tables: {
      chestsOpened: {
        title: 'Chests opened',
        empty: 'No streaks found',
        name: 'Name',
        days: 'Days',
      },
      gamesPlayed: {
        title: 'Games played',
        empty: 'No games found',
        name: 'Name',
        games: 'Games',
      },
      prizeWon: {
        title: 'Prize won',
        empty: 'No prizes found',
        name: 'Name',
        prize: 'Prize',
      },
    },
  },
};
